/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable indent */
import { useQuery } from '@tanstack/react-query';

import React, { useState } from 'react';
import { SortOrder, TableColumn } from 'react-data-table-component';

import { DefaultTable } from 'src/components';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { IEnrollmentEvent } from 'src/interfaces';
import BenefitsService from 'src/services/benefits.service';

const customStyles = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#9399B2',
      font: 'normal normal bold 15px Biotif',
    },
  },
  rows: {
    style: {
      font: 'normal normal normal 14px Biotif',
      color: '#1B1D35',
      borderRadius: '5px',
      '&:not(:last-of-type)': {
        borderBottomWidth: '0px',
      },
    },
    stripedStyle: {
      color: '#1B1D35',
      backgroundColor: '#F3F4F8',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  cells: {
    style: {
      justifyContent: 'left',
    },
  },
  pagination: {
    style: {
      border: 'none',
      svg: {
        fill: 'rgba(0,0,0,0.54)',
      },
    },
  },
};

const columns: TableColumn<IEnrollmentEvent>[] = [
  {
    name: 'Enrollment Event',
    selector: (row: IEnrollmentEvent) => row.name,
  },
  {
    name: 'Enrollment Date',
    selector: (row: IEnrollmentEvent) => `${row.eventStartDate} - ${row.eventEndDate}`,
  },
  {
    name: 'Plan Period',
    selector: (row: IEnrollmentEvent) => `${row.planInitialPeriod} - ${row.planEndPeriod}`,
  },
  {
    name: 'Submission Date',
    selector: (row: IEnrollmentEvent) => row.createdAt || '',
  },
  {
    name: 'Status',
    selector: (row: IEnrollmentEvent) => row.status || '',
  },
  {
    name: 'Enrollment Summary Statement',
    selector: (row: IEnrollmentEvent) => row.message,
  },
];

const EnrollmentTable: React.FC<{ searchTerm: string }> = ({ searchTerm }) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const companyId = useTypedSelector(state => state.config.data?.config?.selectedCompanyId) || '';

  const enrollmentEventsParams = {
    page,
    limit,
    search: searchTerm,
    sortBy,
    sortDirection,
    companyId,
  };

  const { isFetching, data } = useQuery(
    ['benefits/enrollment-historic', enrollmentEventsParams],
    () => BenefitsService.getEnrollmentEvents(enrollmentEventsParams),
    // selectedCompanyId comes from the config store, which may still be loading on first render
    { enabled: !!companyId }
  );

  const handleSort = async (column: TableColumn<IEnrollmentEvent>, newSortDirection: SortOrder) => {
    setSortBy(column.sortField as unknown as string);
    setSortDirection(newSortDirection);
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePerRowsChange = async (newLimit: number, newPage: number) => {
    setLimit(newLimit);
    setPage(newPage);
  };

  return (
    <DefaultTable
      customStyles={customStyles}
      columns={columns}
      data={data?.data.items ?? []}
      progressPending={isFetching}
      pagination
      paginationServer
      paginationTotalRows={data?.data.meta.totalItems}
      onChangeRowsPerPage={handlePerRowsChange}
      onChangePage={handlePageChange}
      onSort={handleSort}
      sortServer
      responsive
    />
  );
};

export default EnrollmentTable;
